import React from 'react';
import { IConfigComponent } from '@ts/ui-models';
import GlobalDataGrid, { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('taskType');

interface ITaskTypesProps {
  inheritedProps?: any;
}

const TaskTypes = (props: ITaskTypesProps) => {
  return <GlobalDataGrid configComponent={defaultConfigComponent} inheritedProps={props.inheritedProps} />;
};

export default TaskTypes;
